export const CV_ANALYSER_MAX = 20;
export const CV_ANALYSER_MB = 5;
